import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import i18n from 'i18n-js';

import { CommonCalendar } from '../../Components/Common/Calendar';

import CommonInputValidation from '../../Container/ComomInputValidation'

const toBase64 = (file: any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const getImage = async (setIsDogImage: any, setStateValue: any, form: any) =>  {
  const inputFile: any = document.querySelector('#file-input-upload');
  const file = inputFile.files[0];
  const data = await toBase64(file);
  setIsDogImage(data);
  setStateValue(
    {
      form: Object.assign(form, {dogImage: {
        value: data,
        required: null,
        errorMessage: '',
        name: 'dogImage'
      }
    })
  });
}

const saveAddDog = async (submitAddDog: any, setIsFormAddDog: any, isSubmitAddDog: boolean) => {
  const isSuccess = await submitAddDog();

  if (isSuccess && !isSubmitAddDog) {
    setIsFormAddDog(false);
    // alert(i18n.t('addDogSuccessfully'));
  }
}

const selectDate = (val: string, form: any, setStateValue: any) => {
  form.dateOfBirth.value = val;
  setStateValue({ form });
}

const FormAddDog = (props: any) => {
  const { isSubmitAddDog, setStateValue, form, dogForm, submitAddDog, setIsFormAddDog } = props;
  const [isDogImage, setIsDogImage] = useState(null);
  const [isLoad, setIsLoad] = useState(null);
  const [isLoadCalendar, setIsLoadCalendar] = useState(false);

  useEffect(() => {
    if (!isLoad) {
      setStateValue(
      {
        form: Object.assign(form, {
          dogOtherImportant: {
            value: null,
            required: true,
            errorMessage: '',
            name: 'dogOtherImportant',
            label: i18n.t('otherImportantInformation')
          },
          dateOfBirth: {
            value: null,
            required: true,
            errorMessage: '',
            name: 'dateOfBirth',
            label: i18n.t('dateOfBirth')
          }
        })
      })

      setIsLoad(true);
    }
  });

  document.addEventListener('click', (e:any) => {
    let container = '.box-booking-dog';

    if (!e.target.closest(container)) {
      setIsLoadCalendar(false);
    }
  });

  return (
    <div className="box-add-dog-form">
      <h1 className="page-title border-bottom">{i18n.t('newDog')}</h1>
      <h1 className="page-title">{i18n.t('dogPhoto')}</h1>
      <div className="box-dog-photo">
        <p className="upload-note">{i18n.t('uploadImage300')}</p>
        {
          isDogImage ?
            <img src={isDogImage} />
            : null
        }
        <div className="row">
          <input id="file-input-upload" className="file-input" type="file" name="dogPhoto" onChange={() => getImage(setIsDogImage, setStateValue, form)} accept="image/x-png,image/gif,image/jpeg" />
          <label>{i18n.t('chooseFile')}</label>
        </div>
      </div>
      <h1 className="page-title">{i18n.t('basicInformationAboutYourDog')}</h1>
      <div className="box-input-field">
        <CommonInputValidation
          label={i18n.t('name')}
          name="dogName"
          required={true}
          setStateValue={setStateValue}
          form={form}
        />
      </div>
      <div className="box-input-field">
        <p>{i18n.t('description')}</p>
        <textarea onChange={(data: any) => {
          setStateValue(
            {
              form: Object.assign(form, {dogDescription: {
                value: data.target.value,
                required: null,
                errorMessage: '',
                name: 'dogDescription'
              }})
            })
          }}
        />
      </div>
      <div className="box-input-field">
        <CommonInputValidation
          label={i18n.t('race')}
          optionList={dogForm && dogForm.race? dogForm.race : []}
          options={{value: 'uid', display: 'description'}}
          name="dogRace"
          required={true}
          setStateValue={setStateValue}
          form={form}
        />
      </div>
      <div className="box-input-field">
        <CommonInputValidation
          label={i18n.t('gender')}
          optionList={dogForm.gender}
          options={{value: 'key', display: 'value'}}
          name="dogGender"
          required={true}
          setStateValue={setStateValue}
          form={form}
        />
      </div>
      <div className="box-input-field">
        <CommonInputValidation
          label={i18n.t('size')}
          optionList={dogForm.size}
          options={{value: 'uid', display: 'description'}}
          name="dogSize"
          required={true}
          setStateValue={setStateValue}
          form={form}
        />
      </div>
      {
        form.dateOfBirth ?
          <div className="box-input-field">
            <p>{i18n.t("dateOfBirth")} <span className="require">*</span></p>
            <div className="box-booking box-booking-dog">
              <input
                readOnly
                defaultValue={form.dateOfBirth.value}
                onClick={() => {
                    if (!isLoadCalendar) {
                      setIsLoadCalendar(true)
                    } else {
                      setIsLoadCalendar(false)
                    }
                }}
              />
              {
                isLoadCalendar ?
                  <CommonCalendar selectDate={(val: string) => selectDate(val, form, setStateValue)} isDefault={true} {...props} />
                  : null
              }
            </div>
            <p className="note">{i18n.t('ifYouDidNotSpecifyYourDog')}</p>
          </div>
          : null
      }
      {
        dogForm.otherInfo ?
          <div className="box-important-info">
            <h4>{i18n.t('otherImportantInformation')} <span className="require">*</span></h4>
            <div className="box-input-field">
              {
                dogForm.otherInfo.map((val: any, key: string) => {
                  return (
                    <Form.Group key={key}>
                      <Form.Check
                        type="checkbox"
                        label={val.description}
                        onChange={(data: any) => {

                          let newData: any = form.dogOtherImportant.value || [];

                          const index = newData.indexOf(val.uid);
                          if (data.target.checked) {
                            newData.push(val.uid);
                          } else if (!data.target.checked) {
                            delete newData[index];
                          }

                          if (newData.length) {
                            newData = newData.filter((el: any) => {
                              return el != null;
                            });
                          }

                          setStateValue(
                            {
                              form: Object.assign(form, {dogOtherImportant: {
                                value: newData,
                                required: true,
                                errorMessage: '',
                                name: 'dogOtherImportant'
                              }})
                            })
                        }}
                      />
                    </Form.Group>
                  )
                })
              }

              {
                dogForm && dogForm.otherInfo && form && form.dogOtherImportant && form.dogOtherImportant.errorMessage ?
                  <p className="require pd-top-5">{form.dogOtherImportant.errorMessage}</p>
                  : null
              }
            </div>
          </div>
          : null
      }

      <div className="box-input-field">
        <CommonInputValidation
          label={i18n.t('veterinarianNameAndContactNumber')}
          name="dogVetname"
          setStateValue={setStateValue}
          form={form}
        />
      </div>
      <div className="box-btn ">
        <button className="red" onClick={() => saveAddDog(submitAddDog, setIsFormAddDog, isSubmitAddDog)}>
          {i18n.t('save')}
        </button>
      </div>
    </div>
  )
}


export default FormAddDog;
